import { BridgeComponent } from '@hotwired/hotwire-native-bridge'

// Native « coup de cœur » button in the product show nav bar (iOS).
//
// Lives INSIDE the favorite turbo-frame (whose web button is hidden on native): every
// toggle re-renders the frame, reconnecting this controller, which pushes the fresh
// state to FavoriteComponent — the native heart is replaced accordingly. Tapping the
// native button clicks the hidden web button, so the whole toggle logic (POST/DELETE,
// policy, frame re-render) stays on the web side.
export default class extends BridgeComponent {
  static component = 'favorite'
  static targets = ['button']
  static values = { favorited: Boolean, interactive: Boolean, label: String }

  connect() {
    super.connect()
    this.send('connect', {
      favorited: this.favoritedValue,
      interactive: this.interactiveValue,
      title: this.labelValue,
    }, () => {
      if (this.hasButtonTarget) this.buttonTarget.click()
    })
  }
}
